export class TenantNotFoundError extends Error {
    constructor(hostname: string) {
        super(`No tenant found for slug "${hostname}"`);
        this.name = 'TenantNotFoundError';
    }
}
